/**
 * Navigation
 */
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

jQuery(document).ready(function ($) {
  class PageNavigation {
    constructor(toggleElement) {
      this.$toggle = $(toggleElement);
      this.$overlay = $(".page-nav-overlay");
      this.overlay = $(".page-nav-overlay")[0];
      this.background = $(".page-nav-overlay__background")[0];
      this.inner = $(".page-nav-overlay__inner")[0];
      this.isOverlayVisible = false;

      this.$toggle.on("click", this._handleToggleClick.bind(this));
    }

    _handleToggleClick(evt) {
      if (this.isOverlayVisible) {
        this.closeOverlay();
      } else {
        this.openOverlay();
      }
    }

    openOverlay() {
      this.isOverlayVisible = true;
      document.body.classList.add("page-nav-overlay-is-visible");
      disableBodyScroll(this.overlay);
      const menuItems = this.overlay.querySelectorAll(".menu > li");
      gsap
        .timeline()
        .set(menuItems, {
          alpha: 0,
          y: 50,
        })
        .to(this.background, { duration: 0.25, alpha: 1 }, 0)
        .to(this.inner, { duration: 0.25, alpha: 1 }, 0)
        .to(
          menuItems,
          {
            alpha: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.05,
          },
          0.3
        );
    }

    closeOverlay() {
      this.isOverlayVisible = false;
      document.body.classList.remove("page-nav-overlay-is-visible");
      enableBodyScroll(this.overlay);
      const menuItems = this.overlay.querySelectorAll(".menu > li");
      gsap
        .timeline()
        .to(menuItems, {
          alpha: 0,
          y: 50,
          duration: 0.5,
          stagger: -0.05,
        })
        .to(this.background, { duration: 0.25, alpha: 0 }, 0.3)
        .to(this.inner, { duration: 0.25, alpha: 0 }, 0.3);
    }
  }

  $(".page-nav-toggle").each((i, toggleElement) => {
    window.luther = window.luther || {};
    window.luther.navigation = new PageNavigation(toggleElement);
  });
});
